<template>
  <div class="tw-flex-1">
    <el-input
      :value="$store.state.v2.foreigner.messaging.fulltextSearchValue"
      type="search"
      :placeholder="$t('common.actions.search')"
      clearable
      @input="handleInput"
    >
      <template #prefix>
        <icon-search />
      </template>
    </el-input>
  </div>
</template>

<script>
import _debounce from 'lodash/debounce';

export default {
  methods: {
    handleInput(value) {
      this.$store.commit('v2/foreigner/messaging/set', ['fulltextSearchValue', value]);
      this.handleSearch();
    },
    handleSearch: _debounce(function() {
      this.$store.commit('v2/foreigner/messaging/set', ['fulltextMessageId', null]);
      this.$store.dispatch('v2/foreigner/messaging/fulltextSearch', {
        foreignerId: this.$store.state.v2.foreigner.foreigner.foreigner.id,
      });
    }, 500),
  },
};
</script>
